import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import ClientMenu from './ClientMenu'
import { CreateClientCallScheduleService, CreateClientCallService, UpdateClientCallService } from '../../services/ClientServices'
import { Modal, Select } from 'antd'

function ClientCallCE() {


  const navigate = useNavigate();
  const { state } = useLocation();
  
  const call_type_arr = [{label:'Incoming',value:'Incoming'},{label:'Outgoing',value:'Outgoing'}]
  const assign_type_arr = [{label:'Self',value:'self'},{label:'Any',value:'any'}]
  const call_status_arr = [{label:'PickUp',value:'PickUp'},{label:'Declined',value:'Declined'}]

  const [data, setdata] = useState({message: '', call_type: '', call_status: '',called_date_time:'',});
  const [error, seterror] = useState({message: '', call_type: '', call_status: '',called_date_time:'',assigned_to:''});


  const [modal,setmodal] = useState(false)

  const [call_followup,setcall_followup] = useState({message:'',customer_call:'',remarks:'',called_date_time:'',assigned_to:''})
  const [call_followup_error,setcall_followup_error] = useState({message:'',customer_call:'',remarks:'',called_date_time:'',assigned_to:''})

  function handleChange2(e){
    setcall_followup({ ...call_followup, [e.target.name]: e.target.value })
    setcall_followup_error({ ...call_followup_error, [e.target.name]: '' })
  }

 
  const toLocalDatetimeInputValue = (utcString) => {
    const date = new Date(utcString);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16);
  };

  useEffect(() => {
    if (state?._id !== null && state?._id !== undefined) {
      let oldData = {...state,call_type:state?.call_type,call_status:state?.call_status,called_date_time:toLocalDatetimeInputValue(state?.called_date_time)}
      delete oldData.client
      setdata({ ...data, ...oldData })
    }
  }, [state])

  function handlechange(e) {
    setdata({ ...data, [e.target.name]: e.target.value })
    seterror({ ...error, [e.target.name]: '' })
  }

  async function submitform() {
    if (!data.message) {
      seterror({ ...error, message: 'Name field is required *' })
    }else if (!data.call_type) {
      seterror({ ...error, call_type: 'Type field is required *' })
    }else if (!data.call_status) {
      seterror({ ...error, call_status: 'Status field is required *' })
    }else if (!data.called_date_time) {
      seterror({ ...error, called_date_time: 'Date/Time field is required *' })
    }else {
      let sendData = { ...data }
      sendData['customer'] =  state?.client?._id

      if (state?._id === undefined || state?._id === null) {
        const response = await CreateClientCallService(sendData)
        if (response.status === 201) {
          resetform()
          toast.success('Client Call Created Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
      } else {
        sendData["id"] = state?._id
        const response = await UpdateClientCallService(sendData, state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Client Call Updated Successfully')
        }
        if (response.status === 422) {
          if (response?.data?.errors?.title) {
            seterror({ ...error, title: response?.data?.errors?.title })
          }
        }
      }
    }
  }

  async function resetform() {
    setdata({message: '', call_type: '', call_status: '',called_date_time:''})
    seterror({message: '', call_type: '', call_status: '',called_date_time:''})

  }

    async function resetform1() {
    setcall_followup({message:'',customer_call:'',remarks:'',called_date_time:'',assigned_to:''})
    setcall_followup_error({message:'',customer_call:'',remarks:'',called_date_time:'',assigned_to:''})

  }

 
  async function handleSelect(e,e1){
    setdata({...data,[e1]:e})
    seterror({...error,[e1]:''})
  }

    async function handleSelect1(e,e1){
    setcall_followup({...call_followup,[e1]:e})
    setcall_followup_error({...call_followup_error,[e1]:''})
  }

  console.log("state",state)

  async function submitCallFollowUp() {
    if(!call_followup?.message){
      setcall_followup_error({...call_followup_error,message:'This field is required*'})
    }else if(!call_followup?.assigned_to){
      setcall_followup_error({...call_followup_error,assigned_to:'This field is required*'})
    }else if(!call_followup?.called_date_time){
      setcall_followup_error({...call_followup_error,called_date_time:'This field is required*'})
    }else{
      let sendData = {...call_followup}
      sendData['customer_call'] = state?._id 
      sendData['customer'] = state?.client?._id


      const response = await CreateClientCallScheduleService(sendData)
      if (response.status === 201) {
        resetform1()
        toast.success('Client Call Scheduled Created Successfully')
      }
      if (response.status === 422) {
        toast.error(JSON.stringify(response?.data?.errors))
      }
      setmodal(false)
    }
    
  }

 
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>



     <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] mb-2 w-full">Create Client Followup</h6>
          <h6 className='bg-slate-100 text-[12px] p-1.5 font-[400]'>Use the below form to create a client followup message</h6>
          

           <TextAreaInput1
            label={'Message'}
            variant="standard"
            name="message"
            type="text"
            error={call_followup_error.message}
            value={call_followup.message}
            handlechange={handleChange2}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }} />   

                <h6 className='text-[12px] font-[400] mb-1 mt-1'>Assign To </h6>
            <Select
              value={call_followup.assigned_to} 
              error={call_followup_error.assigned_to}
              bordered={false}
              placeholder="" 
              onChange={(e)=>handleSelect1(e,'assigned_to')} 
              options={assign_type_arr} 
              style={{fontSize:'12px'}}
              className='w-full border border-l-4 border-l-slate-700 outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
  
              />   

          <ErrorComponent  error={call_followup_error?.call_type} />

          {/* <h6 className='bg-slate-100 p-1 mt-1 text-[11px]'>Be sure while adding time please keep it 5 min before so that it will be flexible to followup</h6> */}

             <TextInput
            type="datetime-local"
            label={'Date Time'}
            mandatory={true}
            variant="standard"
            name="called_date_time"
            error={call_followup_error.called_date_time}
            value={call_followup.called_date_time}
            handlechange={handleChange2}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}
             />

          <ErrorComponent  error={call_followup_error?.called_date_time} />

        
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => submitCallFollowUp()} />
            </div>
          </div>
        </div>
      </Modal>
     

      <div>
      <ClientMenu />
      </div> 
      <div className='mb-5 w-full h-full'>
      <div className='md:flex w-full'>  
        <div className='sm:w-full lg:w-[350px] px-4 pt-5' >


          <GoBack />

          {/* <AudioRecorder /> */}



          <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'} Client Call Info</h6>
          <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b>Client Call Entry details</b> assign to you!.</h6>


          <h6 onClick={()=>setmodal(true)} className='bg-slate-100 w-[100px] mt-2 rounded text-[10px] text-center p-1 cursor-pointer font-[600] border border-slate-300'>Add FollowUp</h6>

          <TextAreaInput1 
            label={'Message'}
            mandatory={true}
            variant="standard"
            name="message"
            type="text"
            error={error.message}
            value={data.message}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}

            />

          <h6 className='text-[12px] font-[400] mb-1 mt-1'>Call Type </h6>
            <Select
              value={data.call_type} 
              error={error.call_type}
              bordered={false}
              placeholder="" 
              onChange={(e)=>handleSelect(e,'call_type')} 
              options={call_type_arr} 
              style={{fontSize:'12px'}}
              className='w-full border border-l-4 border-l-slate-700 outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
  
              />   

          <ErrorComponent  error={error?.call_type} />  



          <h6 className='text-[12px] font-[400] mb-1 mt-1'>Call Status </h6>
            <Select
              value={data.call_status} 
              error={error.call_status}
              bordered={false}
              placeholder="" 
              onChange={(e)=>handleSelect(e,'call_status')} 
              options={call_status_arr} 
              style={{fontSize:'12px'}}
              className='w-full border border-l-4 border-l-slate-700  outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
  
              />   

          <ErrorComponent  error={error?.call_status} />  

           
           <TextInput
            type="datetime-local"
            label={'Date Time'}
            mandatory={true}
            variant="standard"
            name="called_date_time"
            error={error.called_date_time}
            value={data.called_date_time}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
              style: { color: '#fff', },
            }}
             />
          
        

       

          
        <div className='mt-4'>
          <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE" : "ADD"} onClick={submitform} />
        </div>

        </div>

    

      
      </div>

      
      </div> 

    </div>
  )
}

export default ClientCallCE